import { createVuetify } from 'vuetify';
import { VDateInput } from 'vuetify/labs/VDateInput';
import 'vuetify/styles';
import '../assets/styles/custom.scss';
import MomentJsAdapter from '@date-io/moment';
// import * as components from 'vuetify/components'
// import * as directives from 'vuetify/directives'

export default createVuetify({
    components: {
        VDateInput,
    },
    date: {
        adapter: MomentJsAdapter,
    },
    defaults: {
        VBtn: {
            class: 'text-uppercase',
            style: 'letter-spacing: 1.25px;',
        },
        // This applies to all input fields
        VTextField: {
            // Options: 'filled', 'outlined', 'underlined', 'solo', 'plain'
            variant: 'underlined',
        },
        VSelect: {
            variant: 'underlined',
        },
        VAutocomplete: {
            variant: 'underlined',
        },
        VChip: {
            variant: 'flat',
        },
        VSwitch: {
            color: 'ms-orange',
        },
        VDivider: {
            style: '--v-border-opacity: 1;',
        },
    },
    theme: {
        // 'light' | 'dark' | 'system'
        defaultTheme: 'light',
        themes: {
            light: {
                colors: {
                    live: '#e33217',
                    error: '#ff5252',
                    warning: '#fb8c00',
                    'ms-orange': '#ff6c37',
                },
            },
            dark: {
                colors: {
                    live: '#e33217',
                    error: '#ff5252',
                    warning: '#fb8c00',
                    'ms-orange': '#ff6c37',
                },
            },
        },
    },
});
